import { FoodModel } from 'src/app/core/model/object/diet-food-model';
import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { LogoutService } from '../user-repository/logout.service';

@Injectable({
  providedIn: 'root',
})
export class FoodDataService {
  constructor(
    private dbService: NgxIndexedDBService,
    private logoutService: LogoutService
  ) {}

  public async checkFoodIds(foodIds: string[]): Promise<string[]> {
    let response = [];
    for (const foodId of foodIds) {
      const food = await this.getFood(foodId);
      if (!food) {
        response.push(foodId);
      }
    }
    return Promise.resolve(response);
  }
  public async getFoods(foodIds: string[]) {
    let response = [];
    for (const foodId of foodIds) {
      const food = await this.getFood(foodId);
      if (food) {
        response.push(food);
      } else {
        response.push(null);
      }
    }
    return Promise.resolve(response);
  }
  public async getFood(foodId: string): Promise<FoodModel> {
    let food: FoodModel;
    const response = await this.dbService
      .getByIndex('foods', '_id', foodId)
      .then(
        async (f) => {
          if (f) {
            food = new FoodModel(
              f['_id'],
              f['name'],
              f['primaryFoodUnit'],
              f['primaryFoodUnitCalorie'],
              f['foodUnitRatioArray'],
              f['foodFact'],
              f['foodFactModel'],
              null,
              f['recipe']
            );
          } else {
            food = null;
          }
          return food;
        },
        (error) => {
          console.log(error);
          this.logoutService.logout();
          return null;
        }
      );
    return Promise.resolve(response);
  }

  public async saveFoods(res: FoodModel[]): Promise<boolean> {
    if (res.length === 0) {
      return Promise.resolve(true);
    }
    res.forEach(async (food) => {
      this.dbService
        .add('foods', {
          _id: food._id,
          name: food.name,
          primaryFoodUnit: food.primaryFoodUnit,
          primaryFoodUnitCalorie: food.primaryFoodUnitCalorie,
          foodUnitRatioArray: food.foodUnitRatioArray,
          foodFact: food.foodFact,
          foodFactModel: food.foodFactModel,
          recipe: food.recipe,
        })
        .then(
          () => {},
          (error) => {
            console.log(error);
          }
        );
    });
  }

  public async removeFoods(): Promise<boolean> {
    const response = await this.dbService.clear('foods').then(
      () => {
        return true;
        // Do something after clear
      },
      (error) => {
        console.log(error);
        this.logoutService.logout();
        return false;
      }
    );
    return Promise.resolve(response);
  }
}
